import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// Containers
const TheContainer = () => import('@/containers/TheContainer');

// Views
const Items = () => import('@/views/Items');
const LoginPage = () => import('@/views/Login');
const Feats = () => import('@/views/Feats');
const Characters = () => import("@/views/Characters");
const Spells = () => import('@/views/Spells');
const BlackstaffSpells = () => import('@/views/BlackstaffSpells')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404');
// const Page500 = () => import('@/views/pages/Page500')
// const Login = () => import('@/views/pages/Login')
// const Register = () => import('@/views/pages/Register')

// Users
// const Users = () => import('@/views/users/Users')
// const User = () => import('@/views/users/User')

Vue.use(Router)

export default new Router({
    mode: 'hash', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({
        y: 0
    }),
    routes: configRoutes()
})

function configRoutes() {
    return [{
            path: '/',
            redirect: '/homebrew-items',
            name: 'Home',
            component: TheContainer,
            beforeEnter: (to, from, next) => {
                if (to.matched.length > 0) {
                    next();
                } else {
                    next({
                        name: "404"
                    });
                }
            },
            children: [{
                    path: 'homebrew-items',
                    name: 'Homebrew Items',
                    component: Items,
                    beforeEnter: (to, from, next) =>{
                        store.commit('set', ['itemData',store.state.homebrewItemData])
                        next();
                    },
                },
                {
                    path: 'official-items',
                    name: 'Official Items',
                    component: Items,
                    beforeEnter: (to, from, next) =>{
                        store.commit('set', ['itemData', store.state.officialItemData])
                        next();
                    }
                },
                {
                    path: 'login',
                    name: 'Login',
                    component: LoginPage,
                    beforeEnter:(to, from, next) =>{
                        const dataStore = store;
                        if(dataStore.state.loggedIn){
                            next({
                                path:"/items"
                            });
                        } else {
                            next();
                        }
                    },
                    meta: {
                        guest: true
                    }
                },
                {
                    path: 'feats',
                    name: 'Feats',
                    component: Feats
                },
                {
                    path: 'spells',
                    name: 'Spells',
                    component: Spells
                },                 
                {
                    path: "characters",
                    name: "Characters",
                    component: Characters
                },
                {
                    path: "blackstaff_spells",
                    name: "Blackstaff Spells",
                    component: BlackstaffSpells
                }
            ]
        },
        {
            path: "*",
            name: "404",
            component: Page404
        }
    ]
}